import React, { useContext } from 'react';
import { Route } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

export function PrivateRouteLogin({ ...rest }) {
  const { currentUser } = useContext(AuthContext);
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return <Route {...rest} />;
}

export function PrivateRouteRoot({ ...rest }) {
  const { currentUser } = useContext(AuthContext);
  if (currentUser) {
    return <Navigate to="/app" replace />;
  }
  return <Route {...rest} />;
}
